module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_vm._v("Faktury sprzedażowe")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'InvoiceCreate'
      }
    }
  }, [_c('span', [_vm._v("Dodaj fakturę")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.deletedShowMessage != false) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Faktura \"" + _vm._s(_vm.deletedShowMessage) + " \"została usunięta")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.fullNumber),
      callback: function($$v) {
        _vm.$set(_vm.filter, "fullNumber", $$v)
      },
      expression: "filter.fullNumber"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-range-picker', {
    model: {
      value: (_vm.selectedCreateDatePeriod),
      callback: function($$v) {
        _vm.selectedCreateDatePeriod = $$v
      },
      expression: "selectedCreateDatePeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.customer),
      callback: function($$v) {
        _vm.$set(_vm.filter, "customer", $$v)
      },
      expression: "filter.customer"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.currencyTypes,
      "nameField": "name",
      "showEmpty": true,
      "valueField": "id"
    },
    model: {
      value: (_vm.filter.currency),
      callback: function($$v) {
        _vm.$set(_vm.filter, "currency", $$v)
      },
      expression: "filter.currency"
    }
  })], 1), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.statusLists,
      "showEmpty": true,
      "nameField": "name",
      "valueField": "value"
    },
    model: {
      value: (_vm.filter.paid),
      callback: function($$v) {
        _vm.$set(_vm.filter, "paid", $$v)
      },
      expression: "filter.paid"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "no-wrap"
  }, [_c('my-button', {
    attrs: {
      "variant": "info",
      "action": _vm.getItems
    }
  }), _vm._v(" "), _c('my-button', {
    attrs: {
      "icon": "back",
      "variant": "primary",
      "action": _vm.resetFilter
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('fullNumber'),
    on: {
      "click": function($event) {
        return _vm.setOrder('fullNumber')
      }
    }
  }, [_vm._v("Numer")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('createDate'),
    on: {
      "click": function($event) {
        return _vm.setOrder('createDate')
      }
    }
  }, [_vm._v("Data wystawienia")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('customerData.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('customerData.name')
      }
    }
  }, [_vm._v("Nabywca")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('amount'),
    on: {
      "click": function($event) {
        return _vm.setOrder('amount')
      }
    }
  }, [_vm._v("Wartość netto")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('grossAmount'),
    on: {
      "click": function($event) {
        return _vm.setOrder('grossAmount')
      }
    }
  }, [_vm._v("Wartość brutto")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('currency.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('currency.name')
      }
    }
  }, [_vm._v("Waluta")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('paid'),
    on: {
      "click": function($event) {
        return _vm.setOrder('paid')
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [(item.correction) ? _c('span', {
      staticClass: "icon--light"
    }, [_c('svg-icon', {
      attrs: {
        "name": "correction"
      }
    })], 1) : _vm._e(), _vm._v(" " + _vm._s(item['fullNumber']) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("date")(item['createDate'])) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['customerData']['name']) + ", NIP: " + _vm._s(item['customerData']['nip']) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['amount']) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['grossAmount']) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['currency']['name']) + "\n                            ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.id,
            tab: 'invoice'
          }
        }
      }
    }, [(item['paid']) ? _c('span', {
      staticClass: "element_status closed"
    }, [_vm._v("Zapłacona")]) : _vm._e(), _vm._v(" "), (!item['paid'] && !item['deducted']) ? _c('span', {
      staticClass: "element_status open"
    }, [_vm._v("Niezapłacona")]) : _vm._e()])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'InvoiceUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1), _vm._v(" "), (item.paid == false) ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "href": "#",
        "title": "Oznacz jako opłaconą"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.markAsPaid(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "money"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "href": "#",
        "title": "Pobierz"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(item.activeDocumentID)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "download"
      }
    })], 1), _vm._v(" "), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "href": "#",
        "title": "Podgląd"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.previewFile(item.activeDocumentID)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "preview"
      }
    })], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b8e0182","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/List.vue
// module id = 807
// module chunks = 0